export const urlWithoutId = (urlString: string) => {
  const parts = urlString.split("=");
  const urlWithoutNumber = parts[0];
  return urlWithoutNumber;
};
